import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Typography } from '@material-ui/core'

import {
  AcceptedByPrivacyPolicy,
  PublicPrivacyPolicyByPortal,
} from './components'
import { DashboardCounterCard } from 'components'

import constants from 'constants/index'

const DashboardPrivacyPolicy = ({ privacyPolicyStats }) => {
  const { privacyPolicy: privacyPolicyIds } = constants.myLgpd.GRAPH_IDS

  const privacyPolicies = privacyPolicyStats?.privacyPolicies || []

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h4" color="primary">
          Documentos
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={3}>
          <DashboardCounterCard
            label="Quantidade Total de Documentos"
            value={privacyPolicies?.length}
            sizes={{ xs: 12, md: 3 }}
          />
          <Grid item xs={12} md={6}>
            <AcceptedByPrivacyPolicy
              privacyPolicies={privacyPolicies}
              id={privacyPolicyIds.acceptedByPrivacyPolicy}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <PublicPrivacyPolicyByPortal
              privacyPolicies={privacyPolicies}
              id={privacyPolicyIds.publicPrivacyPoliciesByType}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

DashboardPrivacyPolicy.propTypes = {
  privacyPolicyStats: PropTypes.object.isRequired,
}

export default DashboardPrivacyPolicy
